/**
 * Shared sorting utilities for ReportTab components
 */

// Generic sort function for tables
export const sortTableData = (data, sortColumn, sortDirection) => {
  return [...data].sort((a, b) => {
    let aValue, bValue;

    // Handle nested object properties (e.g., 'configInterval.value')
    const getValue = (obj, path) => {
      return path.split('.').reduce((o, p) => o && o[p], obj);
    };

    aValue = getValue(a, sortColumn);
    bValue = getValue(b, sortColumn);

    // Handle string comparison
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      const comparison = aValue.localeCompare(bValue);
      return sortDirection === 'asc' ? comparison : -comparison;
    }

    // Handle numeric comparison
    const comparison = Number(aValue || 0) - Number(bValue || 0);
    return sortDirection === 'asc' ? comparison : -comparison;
  });
};

// Sort icon helper
export const getSortIcon = (column, currentSortColumn, sortDirection) => {
  if (currentSortColumn !== column) return '↕️';
  return sortDirection === 'asc' ? '↑' : '↓';
};

// ARIA sort attribute helper for accessibility
export const getSortAriaSort = (column, currentSortColumn, sortDirection) => {
  if (currentSortColumn !== column) return 'none';
  return sortDirection === 'asc' ? 'ascending' : 'descending';
};

// Keyboard handler for sortable table headers
export const handleSortKeyDown = (event, column, handleSort) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    handleSort(column);
  }
};

// Device sorting specifically for serial numbers
export const sortDevicesBySerial = (devices) => {
  return devices.sort((a, b) => {
    const serialA = (a.serialNumber || '').toString();
    const serialB = (b.serialNumber || '').toString();
    return serialA.localeCompare(serialB);
  });
};